import { Component } from "@angular/core";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { KpiCarouselPanelComponent } from "../kpi-carousel-panel/kpi-carousel-panel.component";
import { NewUiKpiCarouselViewComponent } from "./new-ui-kpi-carousel-view.component";

@Component({
  selector: "app-kpi-carousel-view",
  templateUrl: "./kpi-carousel-view.component.html",
  styleUrl: "./kpi-carousel-view.component.scss",
  imports: [TranslateDirective, KpiCarouselPanelComponent],
})
export class KpiCarouselViewComponent extends NewUiKpiCarouselViewComponent {}
